/* Bearhug stockist locator - used by sections/stockist-locator.liquid */
(function () {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    var API = 'https://api.postcodes.io';
    var MAX = parseInt(root.dataset.maxResults, 10) || 10;
    var form = root.querySelector('.bh-locator__search');
    var input = root.querySelector('.bh-locator__input');
    var status = root.querySelector('.bh-locator__status');
    var geoBtn = root.querySelector('.bh-locator__geo');
    var moreBtn = root.querySelector('.bh-locator__more');
    var list = root.querySelector('.bh-locator__list');
    var items = Array.prototype.slice.call(list.querySelectorAll('.bh-store'));
    items.sort(function (a, b) { return (a.dataset.town || '').localeCompare(b.dataset.town || '') || a.dataset.name.localeCompare(b.dataset.name); });
    items.forEach(function (el) { list.appendChild(el); });

    var map = L.map(root.querySelector('.bh-locator__map'), { scrollWheelZoom: false }).setView([54.3, -3.2], 5);
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
    map.on('focus', function () { map.scrollWheelZoom.enable(); });
    map.on('blur', function () { map.scrollWheelZoom.disable(); });

    var pinIcon = L.divIcon({ className: 'bh-pin', html: '<span></span>', iconSize: [18, 18], iconAnchor: [9, 18], popupAnchor: [0, -18] });
    var activeIcon = L.divIcon({ className: 'bh-pin is-active', html: '<span></span>', iconSize: [24, 24], iconAnchor: [12, 24], popupAnchor: [0, -24] });
    var youIcon = L.divIcon({ className: 'bh-you', html: '<span></span>', iconSize: [16, 16], iconAnchor: [8, 8] });
    var youMarker = null;

    var stores = items.map(function (el) {
      return {
        el: el,
        name: el.dataset.name,
        postcode: (el.dataset.postcode || '').toUpperCase().trim(),
        lat: parseFloat(el.dataset.lat),
        lng: parseFloat(el.dataset.lng),
        marker: null,
        dist: null
      };
    });

    function setStatus(msg, isError) {
      status.textContent = msg || '';
      status.classList.toggle('is-error', !!isError);
    }

    function addMarker(s) {
      var addr = s.el.querySelector('.bh-store__addr').textContent;
      var dir = s.el.querySelector('.bh-store__dir');
      s.marker = L.marker([s.lat, s.lng], { icon: pinIcon, title: s.name })
        .bindPopup('<strong>' + escapeHtml(s.name) + '</strong>' + escapeHtml(addr) + (dir ? '<br><a href="' + dir.href + '" target="_blank" rel="noopener">Directions</a>' : ''))
        .addTo(map);
      s.marker.on('click', function () { highlight(s, false); });
    }

    function escapeHtml(t) {
      return String(t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
    }

    function highlight(s, pan) {
      stores.forEach(function (o) {
        o.el.classList.toggle('is-active', o === s);
        if (o.marker) o.marker.setIcon(o === s ? activeIcon : pinIcon);
      });
      if (s.marker) {
        if (pan) map.setView(s.marker.getLatLng(), Math.max(map.getZoom(), 12));
        s.marker.openPopup();
      }
      if (!pan) s.el.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }

    stores.forEach(function (s) {
      s.el.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        highlight(s, true);
        if (window.innerWidth < 750) root.querySelector('.bh-locator__map').scrollIntoView({ behavior: 'smooth' });
      });
    });

    // Look up any stores that have no saved coordinates (one bulk request)
    function geocodeMissing() {
      var missing = stores.filter(function (s) { return (isNaN(s.lat) || isNaN(s.lng)) && s.postcode; });
      if (!missing.length) return Promise.resolve();
      var pcs = missing.map(function (s) { return s.postcode; });
      var chunks = [];
      for (var i = 0; i < pcs.length; i += 100) chunks.push(pcs.slice(i, i + 100));
      return Promise.all(chunks.map(function (c) {
        return fetch(API + '/postcodes', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ postcodes: c }) })
          .then(function (r) { return r.json(); })
          .then(function (d) {
            (d.result || []).forEach(function (row) {
              if (!row.result || row.result.latitude == null) return;
              missing.forEach(function (s) {
                if (s.postcode === row.query.toUpperCase().trim()) { s.lat = row.result.latitude; s.lng = row.result.longitude; }
              });
            });
          });
      })).catch(function () {});
    }

    function fitAll() {
      var pts = stores.filter(function (s) { return s.marker; }).map(function (s) { return s.marker.getLatLng(); });
      if (pts.length) map.fitBounds(L.latLngBounds(pts), { padding: [30, 30] });
    }

    geocodeMissing().then(function () {
      stores.forEach(function (s) { if (!isNaN(s.lat) && !isNaN(s.lng)) addMarker(s); });
      fitAll();
    });

    function miles(a, b, c, d) {
      var R = 3958.8, toR = Math.PI / 180;
      var dLat = (c - a) * toR, dLng = (d - b) * toR;
      var x = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a * toR) * Math.cos(c * toR) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
      return 2 * R * Math.asin(Math.sqrt(x));
    }

    function showNearest(lat, lng, label) {
      if (youMarker) map.removeLayer(youMarker);
      youMarker = L.marker([lat, lng], { icon: youIcon, title: 'You', zIndexOffset: 1000 }).addTo(map);

      var located = stores.filter(function (s) { return s.marker; });
      located.forEach(function (s) { s.dist = miles(lat, lng, s.lat, s.lng); });
      located.sort(function (a, b) { return a.dist - b.dist; });
      var unlocated = stores.filter(function (s) { return !s.marker; });

      located.concat(unlocated).forEach(function (s, i) {
        list.appendChild(s.el);
        var d = s.el.querySelector('.bh-store__dist');
        if (s.dist != null) { d.textContent = (s.dist < 10 ? s.dist.toFixed(1) : Math.round(s.dist)) + ' miles'; d.hidden = false; }
        s.el.hidden = i >= MAX;
        s.el.classList.remove('is-active');
        if (s.marker) s.marker.setIcon(pinIcon);
      });
      moreBtn.hidden = stores.length <= MAX;
      list.scrollTop = 0;

      var nearest = located.slice(0, 3).map(function (s) { return s.marker.getLatLng(); });
      nearest.push(L.latLng(lat, lng));
      map.fitBounds(L.latLngBounds(nearest), { padding: [40, 40], maxZoom: 13 });

      if (located.length) {
        var n = located[0];
        setStatus('Nearest stockist to ' + label + ': ' + n.name + ' (' + n.el.querySelector('.bh-store__dist').textContent + ')');
      }
    }

    moreBtn.addEventListener('click', function () {
      items.forEach(function (el) { el.hidden = false; });
      moreBtn.hidden = true;
    });

    function getJSON(url) {
      return fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    }

    function lookup(q) {
      var clean = q.trim();
      var pc = clean.replace(/\s+/g, '').toUpperCase();
      var looksLikePostcode = /^[A-Z]{1,2}\d[A-Z\d]?\d[A-Z]{2}$/.test(pc);
      var looksLikeOutcode = /^[A-Z]{1,2}\d[A-Z\d]?$/.test(pc);
      var ok = function (d) { return d && d.result && d.result.latitude != null; };

      if (looksLikePostcode) {
        return getJSON(API + '/postcodes/' + encodeURIComponent(pc)).then(function (d) {
          if (ok(d)) return { lat: d.result.latitude, lng: d.result.longitude, label: d.result.postcode };
          return getJSON(API + '/terminated_postcodes/' + encodeURIComponent(pc)).then(function (t) {
            if (ok(t)) return { lat: t.result.latitude, lng: t.result.longitude, label: clean.toUpperCase() };
            return getJSON(API + '/outcodes/' + encodeURIComponent(pc.slice(0, -3))).then(function (o) {
              return ok(o) ? { lat: o.result.latitude, lng: o.result.longitude, label: o.result.outcode } : null;
            });
          });
        });
      }
      if (looksLikeOutcode) {
        return getJSON(API + '/outcodes/' + encodeURIComponent(pc)).then(function (o) {
          return ok(o) ? { lat: o.result.latitude, lng: o.result.longitude, label: o.result.outcode } : null;
        });
      }
      return getJSON(API + '/places?limit=10&q=' + encodeURIComponent(clean)).then(function (d) {
        var rows = (d && d.result) || [];
        if (!rows.length) return null;
        var order = ['City', 'Town', 'Village', 'Hamlet', 'Suburban Area', 'Other Settlement'];
        rows.sort(function (a, b) {
          var ea = a.name_1.toLowerCase() === clean.toLowerCase() ? 0 : 1;
          var eb = b.name_1.toLowerCase() === clean.toLowerCase() ? 0 : 1;
          if (ea !== eb) return ea - eb;
          var ia = order.indexOf(a.local_type), ib = order.indexOf(b.local_type);
          return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
        });
        var p = rows[0];
        return { lat: p.latitude, lng: p.longitude, label: p.name_1 + (p.county_unitary ? ', ' + p.county_unitary : '') };
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input.value;
      if (!q.trim()) { setStatus('Please enter a postcode or town.', true); input.focus(); return; }
      setStatus('Searching…');
      lookup(q).then(function (loc) {
        if (!loc) { setStatus('We couldn’t find "' + q.trim() + '". Please check the postcode or try a nearby town.', true); return; }
        showNearest(loc.lat, loc.lng, loc.label);
      });
    });

    if (!('geolocation' in navigator)) { geoBtn.hidden = true; }
    geoBtn.addEventListener('click', function () {
      setStatus('Finding your location…');
      navigator.geolocation.getCurrentPosition(function (pos) {
        showNearest(pos.coords.latitude, pos.coords.longitude, 'your location');
      }, function () {
        setStatus('We couldn’t get your location. Please enter your postcode instead.', true);
      }, { timeout: 10000, maximumAge: 600000 });
    });
  }

  function start() {
    if (!window.L) { return setTimeout(start, 50); }
    document.querySelectorAll('.bh-locator').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);
})();